import React from "react";
import PropTypes from "prop-types";
import DocumentViewer from "../../common/DocumentViewer/DocumentViewer";
/*istanbul ignore next */
const MemoizedDocumentViewer = React.memo(({ documents, fileType }) => {
  return (
    <DocumentViewer
      disableHeader={true}
      tempId={fileType + "_" + documents?.[0]?.fileName}
      documents={documents}
      config={{
        noRenderer: {
          overrideComponent: <div>No Document uploaded</div>,
        },
      }}
    />
  );
});

MemoizedDocumentViewer.propTypes = {
  fileType: PropTypes.string.isRequired,
  documents: PropTypes.arrayOf(
    PropTypes.shape({
      fileName: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default MemoizedDocumentViewer;
